export const DEFAULT_BANNER_IMAGE = 'https://default-banner-image.jpg';
